import axios from '@/api/requests/axios'

export default {
  getAll: (params) => axios.get(`/api/admin/v1/branches`, { params }),
  sync: (restaurant) => axios.put(`/api/admin/v1/branches`, restaurant),
  updateCity: (branch) => axios.put(`/api/admin/v1/branches/city`, branch),
  getById: (id) => axios.get(`/api/admin/v1/branches/${id}`),
  updateVisibility: (branch) => axios.put(`/api/admin/v1/branches/visibility`, branch)
}
